import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  deviceRepositoryList,
  deviceRepositoryCreateReset,
  deviceRepositoryCreate,
  deviceRepositoryUpdate,
  deviceRepositoryDelete,
  deviceRepositorySelect
} from '../../redux/actions'

import {
  getActiveLanguage
} from 'react-localize-redux'

import {
  preparePager,
  prepareSearch
} from '../../common/tabletools'

import NoData from '../../components/nodata'
import DeviceUpdateRepositories from '../../components/deviceupdaterepositories'

class DeviceUpdateRepositoriesPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pager: {
        defaultColumns: ['name', 'isdefault'],
        manual: true,
        pageno: 1,
        pagesize: 5,
        order: {},
        search: [],
        global: false
      }
    }
    this.fetch = this.fetch.bind(this);
    this.search = this.search.bind(this);
  }

  componentWillMount() {
    this.props.reset()
    this.props.getDeviceRepositories(this.state.pager);
  }
 
  fetch(table) {
    const { pager } = this.state
    if (!pager.global)
    this.props.getDeviceRepositories(preparePager(table, pager))
    else {
      let search = pager.search
      let pagers = preparePager(table, pager)
      if (pagers.search.length > 0) {
        pagers.search = [...search, ...pagers.search]
      }
      else {
        pagers.search = search
      }
      this.props.getDeviceRepositories(pagers)
    }
  }

  search(term) {
    const { repositories } = this.props;
    const { columns } = repositories;
    const { pager } = this.state;
    const _pager = prepareSearch(term, columns, pager)
    _pager.global = term === '' ? false : true
    this.setState({
      pager: _pager
    });

    this.props.getDeviceRepositories(_pager);
  }

  render() {
    const {
      translate,
      languages,
      create,
      created,
      repositoryId,
      repository,
      repositories,
      getDeviceRepository,
      update,
      del,
      reset
    } = this.props;

    const {
      pager
    } = this.state

    return (
      (repositories) ? (
        <DeviceUpdateRepositories
          translate={translate}
          languages={languages}
          create={create}
          created={created}
          repositoryId={repositoryId}
          repository={repository}
          repositories={repositories}
          pager={pager}
          update={update}
          fetch={this.fetch}
          search={this.search}
          reset={reset}
          get={getDeviceRepository}
          del={del}
        />
      ) : (
          <NoData translate={translate} />
        )
    )
  }
}

const mapStateToProps = (state) => ({
  languages: state.localeReducer.languages,
  repositoryId: state.deviceRepositoryReducer.repositoryId,
  repository: state.deviceRepositoryReducer.repository,
  repositories: state.deviceRepositoryReducer.repositories,
  created: state.deviceRepositoryReducer.created,
  updated: state.deviceRepositoryReducer.updated,
  activeLanguage: getActiveLanguage(state.localeReducer).code,
  ...state,
})

const mapDispatchToProps = (dispatch, props) => ({
  getDeviceRepositories: (pager) => {
    dispatch(deviceRepositoryList(pager))
  },
  create: (repository, pager) => {
    return dispatch(deviceRepositoryCreate(repository, pager))
  },
  update: (repository, pager) => {
    return dispatch(deviceRepositoryUpdate(repository, pager))
  },
  getDeviceRepository: (id) => {
    dispatch(deviceRepositorySelect(id))
  },
  reset: () => {
    dispatch(deviceRepositoryCreateReset())
  },
  del: (id, pager) => {
   return dispatch(deviceRepositoryDelete(id, pager))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceUpdateRepositoriesPage)
